import classNames from 'classnames';
import React, { JSX } from 'react';
import { useSenderName } from './hooks';
import { type SenderSource } from '@enuan/chat__utils';

/** Sender props: span attributes plus required sender. */
type ISenderProps = JSX.IntrinsicElements['span'] & { sender: SenderSource };

/**
 * Text label for the message sender (Agent, System, User).
 *
 * **Behaviour:**
 * - Uses the useSenderName() hook (getter) to get the localized string from SenderSource (AGENT → "Agent", SYSTEM → "System", USER → "User", other → capitalized value).
 * - Renders a span with classes message__sender and Message-sender containing that name.
 * - Used by MessageHeader when customHeader is not used and hideSender is false.
 *
 * @param {ISenderProps} props - sender (required), className and span attributes
 * @returns {JSX.Element} Span with the localized sender name
 */
export const Sender = ({ sender, className, ...props }: ISenderProps) => {
	const getSenderName = useSenderName();
	const senderName = getSenderName(sender);
	return (
		<span
			className={classNames('message__sender', 'Message-sender', className)}
			{...props}
		>
			{senderName}
		</span>
	);
};
